//
//
//
//
//
//
//

import Vue from "vue";
import YmapPlugin, {
  loadYmap
} from "vue-yandex-maps";

const settings = {
  apiKey: process.env.yandexMapApiKey,
  lang: "ru_RU",
  coordorder: "latlong",
  version: "2.1",
};
Vue.use(YmapPlugin, settings);

export default {
  name: "MapCard",

  data: function () {
    const strKey = (Math.random() + 1).toString(36).substring(7);

    return {
      points: [],

      yandexMap: null,

      strKey
    }
  },

  props: {
    init: {
      type: Boolean,
      default: false
    }
  },

  mounted: async function () {
    if (this.init) {
      await this.getPoints();
    }
  },

  watch: {
    init: async function () {
      if (this.init) {
        await this.getPoints();
      }
    }
  },

  methods: {
    getPoints: async function () {
      const cityId = this.$store.state?.appState?.config?.city?.data?.id || 1;

      let response = await this.$api.agent.transport.get(`/stores?filter[city_id]=${cityId}`).then((res) => {
        return res?.data || []
      }).catch(() => {
        return []
      });
      if (response.length <= 0) {
        response = await this.$api.agent.transport.get(`/stores?filter[city_id]=1`).then((res) => {
          return res?.data || []
        }).catch(() => {
          return []
        });
      }

      this.points = response;

      await this.yandexMapInit();
    },

    // Инициализация и удаление карты
    yandexMapInit: async function () {
      const parent = document.getElementById('CardsCarouselBlockMapCard');
      if (!parent) {
        setTimeout(async () => {
          await this.yandexMapInit();
        }, 500)
        return
      }

      await loadYmap({...settings, debug: true});
      const store = this.points?.[0] || {};

      if (!ymaps.Map) {
        setTimeout(async () => {
          await this.yandexMapInit();
        }, 500)
        return
      }
      this.yandexMap = new ymaps.Map(this.$refs[`refYandexMap${this.strKey}`], {
        center: [store.lat, store.lon],
        zoom: 12,
        behaviors: ['drag', 'dblClickZoom', 'multiTouch']
      }, {
        maxZoom: 17
      });

      this.yandexMapSetMarkers();
    },
    yandexMapSetMarkers: function () {
      const yandexMap = this.yandexMap;
      const self = this;
      this.points.map((store) => {
        let MyIconContentLayout = ymaps.templateLayoutFactory.createClass(`<div class="store-map-pointer ${Boolean(this.activeShop === store.id || this.points.length === 1) ? ' store-map-pointer--active' : ''}"><span>${store.address}</span></div>`);
        let myPlacemarkWithContent = new ymaps.Placemark([store.lat, store.lon], {}, {
          iconLayout: "default#imageWithContent",
          iconImageHref: '',
          content: "",
          contentLayout: "",
          imageSize: [60, 60],
          imageOffset: [-30, -30],
          contentOffset: [30, 20],
          iconContentLayout: MyIconContentLayout
        })
        myPlacemarkWithContent.events.add('click', function () {
          self.$emit('clickPoint', store);
        });

        yandexMap.geoObjects.add(myPlacemarkWithContent);
      });
      yandexMap.setBounds(yandexMap.geoObjects.getBounds(), {checkZoomRange: true, zoomMargin: [80, 0]});
    },
    yandexMapDestroy: async function () {
      await this.yandexMap?.geoObjects?.removeAll();
    },
  }
}
